"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RedemptionPayoutMethod = exports.DealingFrequency = exports.InvestorTreatment = exports.DayCountBasis = exports.RoundingMethod = exports.WalletType = exports.ShareTokenisationStandard = exports.RegistryType = exports.BglImportStatus = exports.InvestorKind = exports.OwnerType = exports.CertificateDownloadStatus = exports.CertificateType = exports.FundraiseRoundType = exports.ActivityType = exports.ActivitySubType = exports.FundraiseOfferType = exports.CompanyStatus = exports.CompanyListItemStatus = exports.TrusteeType = exports.EntityType = void 0;
var EntityType;
(function (EntityType) {
    EntityType["INDIVIDUAL"] = "individual";
    EntityType["COMPANY"] = "company";
    EntityType["TRUST"] = "trust";
    EntityType["SMSF"] = "smsf";
    EntityType["JOINT"] = "joint";
})(EntityType || (exports.EntityType = EntityType = {}));
var TrusteeType;
(function (TrusteeType) {
    TrusteeType["INDIVIDUAL"] = "individual";
    TrusteeType["COMPANY"] = "company";
})(TrusteeType || (exports.TrusteeType = TrusteeType = {}));
var CompanyListItemStatus;
(function (CompanyListItemStatus) {
    CompanyListItemStatus["ReadyForReview"] = "Ready for Review";
    CompanyListItemStatus["KYCPending"] = "KYC Pending";
    CompanyListItemStatus["SetUpInProgress"] = "Set up in progress";
    CompanyListItemStatus["AddPaymentMethod"] = "Add Payment Method";
    CompanyListItemStatus["Active"] = "Active";
})(CompanyListItemStatus || (exports.CompanyListItemStatus = CompanyListItemStatus = {}));
var CompanyStatus;
(function (CompanyStatus) {
    CompanyStatus["ReadyForReview"] = "Ready for Review";
    CompanyStatus["KYCPending"] = "KYC Pending";
    CompanyStatus["SetUpInProgress"] = "Set up in progress";
    CompanyStatus["AddPaymentMethod"] = "Add Payment Method";
    CompanyStatus["Active"] = "Active";
})(CompanyStatus || (exports.CompanyStatus = CompanyStatus = {}));
var FundraiseOfferType;
(function (FundraiseOfferType) {
    FundraiseOfferType["ALL"] = "all";
    FundraiseOfferType["UNPAID"] = "unpaid";
    FundraiseOfferType["PENDING_RECONCILIATION"] = "pending_reconciliation";
    FundraiseOfferType["PAID"] = "paid";
    FundraiseOfferType["CANCELLED"] = "cancelled";
})(FundraiseOfferType || (exports.FundraiseOfferType = FundraiseOfferType = {}));
var ActivitySubType;
(function (ActivitySubType) {
    ActivitySubType["SET_SHARE_PRICE"] = "SET SHARE PRICE";
    ActivitySubType["SHARE_CLASS_CREATED"] = "SHARE CLASS CREATED";
    ActivitySubType["VAULT_CREATED"] = "VAULT CREATED";
    ActivitySubType["VAULT_PAUSED"] = "VAULT PAUSED";
    ActivitySubType["VAULT_UNPAUSED"] = "VAULT UNPAUSED";
    ActivitySubType["VAULT_REQUESTS_SWITCHED"] = "VAULT REQUESTS SWITCHED";
    ActivitySubType["VAULT_FREE_CASH_WITHDRAWN"] = "VAULT FREE CASH WITHDRAWN";
    ActivitySubType["VAULT_CASH_TOPPED_UP"] = "VAULT CASH TOPPED UP";
    ActivitySubType["VAULT_SHORTFALL_COVERED"] = "VAULT SHORTFALL COVERED";
    ActivitySubType["VAULT_INFLOW_RECOGNISED"] = "VAULT INFLOW RECOGNISED";
    ActivitySubType["VAULT_PRICES_PUBLISHED"] = "VAULT PRICES PUBLISHED";
    ActivitySubType["VAULT_ALERT"] = "VAULT ALERT";
    ActivitySubType["CONTRACT_OWNERSHIP_TRANSFERRED"] = "CONTRACT OWNERSHIP TRANSFERRED";
    ActivitySubType["APPOINT_OFFICEHOLDER"] = "APPOINT OFFICEHOLDER";
    ActivitySubType["REMOVE_OFFICEHOLDER"] = "REMOVE OFFICEHOLDER";
    ActivitySubType["UPDATE_OFFICEHOLDER"] = "UPDATE OFFICEHOLDER";
    ActivitySubType["CHANGE_ADDRESS"] = "CHANGE ADDRESS";
    ActivitySubType["SHARE_ISSUE"] = "SHARE ISSUE";
    ActivitySubType["SHARE_TRANSFER"] = "SHARE TRANSFER";
    ActivitySubType["ALLOCATE_SHARES"] = "ALLOCATE EXISTING SHARES";
    ActivitySubType["NOTE_ISSUE"] = "NOTE ISSUE";
    ActivitySubType["ANNOUNCEMENT_CREATED"] = "ANNOUNCEMENT CREATED";
    ActivitySubType["ASIC_SUBMISSION"] = "ASIC SUBMISSION";
    ActivitySubType["ASIC_SUBMISSION_REJECTED"] = "ASIC SUBMISSION REJECTED";
    ActivitySubType["ASIC_SUBMISSION_ACCEPTED"] = "ASIC SUBMISSION ACCEPTED";
    ActivitySubType["ADD_VESTING"] = "ADD VESTING";
    ActivitySubType["DELETE_VESTING"] = "DELETE VESTING";
    ActivitySubType["CONVERSION"] = "CONVERSION";
    ActivitySubType["PAID"] = "PAY OUT";
    ActivitySubType["GRANT_OPTIONS"] = "GRANT OPTIONS";
    ActivitySubType["CREATE_OPTION_POOL"] = "CREATE OPTION POOL";
    ActivitySubType["UPDATE_OPTION_POOL"] = "EDIT OPTION POOL";
    ActivitySubType["DELETE_OPTION_POOL"] = "DELETE OPTION POOL";
    ActivitySubType["EXERCISE_OPTION"] = "EXERCISE";
    ActivitySubType["CREATE_FUNDRAISE_ROUND"] = "CREATE FUNDRAISE ROUND";
    ActivitySubType["SEND_FUNDRAISE_OFFER"] = "OFFER SENT";
    ActivitySubType["CANCEL_FUNDRAISE_OFFER"] = "OFFER CANCELLED";
    ActivitySubType["EDIT_FUNDRAISE_ROUND"] = "EDIT ROUND";
    ActivitySubType["DELETE_FUNDRAISE_ROUND"] = "DELETE ROUND";
    ActivitySubType["ACTIVATE_FUNDRAISES"] = "ACTIVATE FUNDRAISES";
    ActivitySubType["ACTIVATE_SHARE_CERTIFICATES"] = "ACTIVATE SHARE CERTIFICATES";
    ActivitySubType["DEACTIVATE_SHARE_CERTIFICATES"] = "DEACTIVATE SHARE CERTIFICATES";
    ActivitySubType["UPDATE_SHARE_CERTIFICATE_CONFIGURATION"] = "UPDATE SHARE CERTIFICATE CONFIGURATION";
    ActivitySubType["ACTIVATE_NOTE_CERTIFICATES"] = "ACTIVATE NOTE CERTIFICATES";
    ActivitySubType["DEACTIVATE_NOTE_CERTIFICATES"] = "DEACTIVATE NOTE CERTIFICATES";
    ActivitySubType["UPDATE_NOTE_CERTIFICATE_CONFIGURATION"] = "UPDATE NOTE CERTIFICATE CONFIGURATION";
    ActivitySubType["UPDATED"] = "UPDATED";
    ActivitySubType["DELETED"] = "DELETED";
    ActivitySubType["EDIT_GRANT"] = "EDIT OPTIONS GRANT";
    ActivitySubType["DELETE_GRANT"] = "DELETE OPTIONS GRANT";
    ActivitySubType["API_CREDENTIAL_CREATED"] = "API CREDENTIAL CREATED";
    ActivitySubType["API_CREDENTIAL_REVOKED"] = "API CREDENTIAL REVOKED";
    ActivitySubType["ACT_ON_BEHALF_REQUESTED"] = "ACT-ON-BEHALF REQUESTED";
    ActivitySubType["ACT_ON_BEHALF_APPROVED"] = "ACT-ON-BEHALF APPROVED";
    ActivitySubType["ACT_ON_BEHALF_DECLINED"] = "ACT-ON-BEHALF DECLINED";
    ActivitySubType["ACT_ON_BEHALF_REVOKED"] = "ACT-ON-BEHALF REVOKED";
    ActivitySubType["WHOLESALE_VERIFICATION_RECORDED"] = "WHOLESALE VERIFICATION RECORDED";
    ActivitySubType["WHOLESALE_VERIFICATION_UPDATED"] = "WHOLESALE VERIFICATION UPDATED";
    ActivitySubType["REDEMPTION_REQUESTED"] = "REDEMPTION REQUESTED";
    ActivitySubType["REDEMPTION_CANCELLED"] = "REDEMPTION CANCELLED";
    ActivitySubType["REDEMPTION_ACCEPTED"] = "REDEMPTION ACCEPTED";
    ActivitySubType["REDEMPTION_REJECTED"] = "REDEMPTION REJECTED";
    ActivitySubType["REDEMPTION_DECIDED_OUT_OF_BAND"] = "DECIDED OUT OF BAND";
    ActivitySubType["REDEMPTION_WINDOW_APPROVED"] = "WINDOW APPROVED";
    ActivitySubType["REDEMPTION_WINDOW_COMPLETED"] = "WINDOW COMPLETED";
    ActivitySubType["REDEMPTION_PAYMENT_CONFIRMED"] = "PAYMENT CONFIRMED";
    ActivitySubType["REDEMPTION_REFUND_CLAIMED"] = "REFUND CLAIMED";
    ActivitySubType["SUBSCRIPTION_LODGED"] = "APPLICATION LODGED";
    ActivitySubType["SUBSCRIPTION_WITHDRAWN"] = "APPLICATION WITHDRAWN";
    ActivitySubType["SUBSCRIPTION_PAYMENT_DECLARED"] = "PAYMENT DECLARED";
    ActivitySubType["SUBSCRIPTION_ACCEPTED"] = "APPLICATION ACCEPTED";
    ActivitySubType["SUBSCRIPTION_REJECTED"] = "APPLICATION REJECTED";
    ActivitySubType["SUBSCRIPTION_WINDOW_APPROVED"] = "WINDOW APPROVED";
    ActivitySubType["SUBSCRIPTION_PAYMENT_RECONCILED"] = "PAYMENT RECONCILED";
    ActivitySubType["SUBSCRIPTION_ALLOTMENT_COMPLETED"] = "ALLOTMENT RUN COMPLETED";
    ActivitySubType["SUBSCRIPTION_APPROVED"] = "APPLICATION APPROVED";
    ActivitySubType["SUBSCRIPTION_ISSUED"] = "UNITS ISSUED";
    ActivitySubType["SUBSCRIPTION_REFUND_CLAIMED"] = "REFUND CLAIMED";
    ActivitySubType["YIELD_TURNED_ON"] = "YIELD TURNED ON";
    ActivitySubType["YIELD_TURN_ON_SUBMITTED"] = "YIELD TURN-ON SUBMITTED";
    ActivitySubType["YIELD_TURN_ON_REJECTED"] = "YIELD TURN-ON REJECTED";
    ActivitySubType["ACCRUAL_RATE_SUBMITTED"] = "RATE CHANGE SUBMITTED";
    ActivitySubType["ACCRUAL_RATE_APPROVED"] = "RATE CHANGE APPROVED";
    ActivitySubType["ACCRUAL_RATE_REJECTED"] = "RATE CHANGE REJECTED";
    ActivitySubType["ACCRUAL_RATE_CHANGED"] = "RATE CHANGED";
    ActivitySubType["ROUNDING_CHANGE_SUBMITTED"] = "ROUNDING CHANGE SUBMITTED";
    ActivitySubType["ROUNDING_CHANGE_APPROVED"] = "ROUNDING CHANGE APPROVED";
    ActivitySubType["ROUNDING_CHANGE_REJECTED"] = "ROUNDING CHANGE REJECTED";
    ActivitySubType["ROUNDING_METHOD_CHANGED"] = "ROUNDING METHOD CHANGED";
    ActivitySubType["ACCRUED_UNITS_MINTED"] = "ACCRUED UNITS MINTED";
})(ActivitySubType || (exports.ActivitySubType = ActivitySubType = {}));
var ActivityType;
(function (ActivityType) {
    ActivityType["SHARES"] = "SHARES";
    ActivityType["COMPANY_INFORMATION"] = "COMPANY INFORMATION";
    ActivityType["REGISTER"] = "REGISTER";
    ActivityType["ANNOUNCEMENT"] = "ANNOUNCEMENT";
    ActivityType["ASIC"] = "ASIC";
    ActivityType["OPTIONS"] = "OPTIONS";
    ActivityType["NOTES"] = "NOTES";
    ActivityType["FUNDRAISE"] = "FUNDRAISING";
    ActivityType["SHARE_CERTIFICATE"] = "SHARE CERTIFICATES";
    ActivityType["NOTE_CERTIFICATE"] = "NOTE CERTIFICATES";
    ActivityType["INVESTOR_DETAILS"] = "INVESTOR DETAILS";
    ActivityType["INVESTOR_CONTACT"] = "INVESTOR CONTACT";
    ActivityType["REDEMPTION"] = "REDEMPTIONS";
    ActivityType["SUBSCRIPTION"] = "SUBSCRIPTIONS";
    ActivityType["ACCRUAL_RATES"] = "ACCRUAL RATES";
    ActivityType["ACCRUED_UNITS"] = "ACCRUED UNITS";
})(ActivityType || (exports.ActivityType = ActivityType = {}));
var FundraiseRoundType;
(function (FundraiseRoundType) {
    FundraiseRoundType["SHARE"] = "shares";
    FundraiseRoundType["NOTE"] = "notes";
})(FundraiseRoundType || (exports.FundraiseRoundType = FundraiseRoundType = {}));
var CertificateType;
(function (CertificateType) {
    CertificateType["NOTES"] = "notes";
    CertificateType["SHARES"] = "shares";
})(CertificateType || (exports.CertificateType = CertificateType = {}));
var CertificateDownloadStatus;
(function (CertificateDownloadStatus) {
    CertificateDownloadStatus["PENDING"] = "pending";
    CertificateDownloadStatus["COMPLETED"] = "completed";
})(CertificateDownloadStatus || (exports.CertificateDownloadStatus = CertificateDownloadStatus = {}));
var OwnerType;
(function (OwnerType) {
    OwnerType["INDIVIDUAL"] = "individual";
    OwnerType["JOINT"] = "joint";
    OwnerType["COMPANY"] = "company";
})(OwnerType || (exports.OwnerType = OwnerType = {}));
// The single "Who is investing?" answer. Presentation-level only: it is never persisted, and maps
// onto the stored `isTrustOrSMSF` + `ownerType` pair.
var InvestorKind;
(function (InvestorKind) {
    InvestorKind["INDIVIDUAL"] = "individual";
    InvestorKind["JOINT"] = "joint";
    InvestorKind["COMPANY"] = "company";
    InvestorKind["TRUST_SMSF"] = "trustSmsf";
})(InvestorKind || (exports.InvestorKind = InvestorKind = {}));
var BglImportStatus;
(function (BglImportStatus) {
    BglImportStatus["INACTIVE"] = "inactive";
    BglImportStatus["STARTED"] = "started";
    BglImportStatus["COMPLETED"] = "completed";
    BglImportStatus["FAILED"] = "failed";
})(BglImportStatus || (exports.BglImportStatus = BglImportStatus = {}));
/**
 * Persisted business classification of a company record. An unset stored value means
 * `Company`. Live fund-versus-company behaviour still reads the `unit-registry` feature flag.
 */
var RegistryType;
(function (RegistryType) {
    RegistryType["Company"] = "company";
    RegistryType["Fund"] = "fund";
    RegistryType["Security"] = "security";
})(RegistryType || (exports.RegistryType = RegistryType = {}));
/** Persisted on company at creation; drives legacy ERC-20-style Liquidise mint vs ERC-3643 RWA API. */
var ShareTokenisationStandard;
(function (ShareTokenisationStandard) {
    ShareTokenisationStandard["Legacy"] = "legacy";
    ShareTokenisationStandard["Erc3643"] = "erc3643";
})(ShareTokenisationStandard || (exports.ShareTokenisationStandard = ShareTokenisationStandard = {}));
var WalletType;
(function (WalletType) {
    WalletType["AVERER"] = "averer";
    WalletType["TOKENISER_MANAGED"] = "tokeniser-managed";
})(WalletType || (exports.WalletType = WalletType = {}));
var RoundingMethod;
(function (RoundingMethod) {
    RoundingMethod["ROUND_UP"] = "Round up";
    RoundingMethod["ROUND_DOWN"] = "Round down";
    RoundingMethod["TRUNCATE"] = "Truncate";
})(RoundingMethod || (exports.RoundingMethod = RoundingMethod = {}));
var DayCountBasis;
(function (DayCountBasis) {
    DayCountBasis["ACTUAL_365"] = "actual/365";
    /** A day in a leap year divides the annual rate by 366. */
    DayCountBasis["ACTUAL_ACTUAL"] = "actual/actual";
})(DayCountBasis || (exports.DayCountBasis = DayCountBasis = {}));
var InvestorTreatment;
(function (InvestorTreatment) {
    InvestorTreatment["PAYOUT"] = "Payout";
    InvestorTreatment["REINVEST"] = "Reinvest";
    InvestorTreatment["AUTO"] = "Auto";
})(InvestorTreatment || (exports.InvestorTreatment = InvestorTreatment = {}));
/** How often a fund deals redemptions. `MONTHLY`/`QUARTERLY` deal on the calendar period end. */
var DealingFrequency;
(function (DealingFrequency) {
    DealingFrequency["DAILY"] = "daily";
    DealingFrequency["WEEKLY"] = "weekly";
    DealingFrequency["MONTHLY"] = "monthly";
    DealingFrequency["QUARTERLY"] = "quarterly";
    /** An explicit list of dealing dates supplied by the fund. */
    DealingFrequency["CUSTOM"] = "custom";
})(DealingFrequency || (exports.DealingFrequency = DealingFrequency = {}));
/** Payout rail for a redemption. Bank transfer only for now. */
var RedemptionPayoutMethod;
(function (RedemptionPayoutMethod) {
    RedemptionPayoutMethod["ABA"] = "aba";
})(RedemptionPayoutMethod || (exports.RedemptionPayoutMethod = RedemptionPayoutMethod = {}));
//# sourceMappingURL=index.js.map